
<template>
  <BtnToggle 
    :class="{ active: active }"
    :title="$t('engine.manageText.modalWidget.tooltip.lblUnderline', languageEngine)"
    @click="onClick(!value)"
  >
    <i class="far fa-underline fs-16"></i>
  </BtnToggle>
</template>

<script>
import { mapGetters } from "vuex";
import BtnToggle from "./_BtnToggle";

export default {
  components: {
    BtnToggle,
  },
  props: {},
  data() {
    return {
      active: false,
    }
  },
  computed: {
    ...mapGetters({
      languageEngine: "designIframe/userPreference/languageEngine",
      texteditor: "designIframe/texteditor/texteditor",
    }),
    selectionFormatMerge() {
      return this.texteditor.selectionFormatMerge;
    },
    selectionFormatTemplate() {
      return this.texteditor.selectionFormatTemplate;
    },
    value() {
      //   if (this.texteditor.selectionFormatTemplate.decoration == 'underline') return true;
      if (this.selectionFormatMerge.decoration == 'unset') return false;
      if (this.selectionFormatMerge.decoration == 'none') return false;
      if (this.selectionFormatMerge.decoration == 'underline') return true;
      return Boolean(this.selectionFormatMerge.underline);
    },
  },
  methods: {
    onClick(value) {
      if (Object.prototype.hasOwnProperty.call(this.selectionFormatTemplate, 'decoration')) {
        this.active = (this.selectionFormatTemplate.decoration == 'underline') ? true : value;
      } else {
        this.active = value;
      }

      if (value) {
        this.texteditor.editor.format("underline", true);
        this.texteditor.editor.format("decoration", false);
      } else if (Object.prototype.hasOwnProperty.call(this.selectionFormatTemplate, 'decoration') && !value && this.selectionFormatTemplate.decoration == 'underline') {
        this.texteditor.editor.format("underline", false);
        this.texteditor.editor.format("decoration", 'none');
      } else {
        this.texteditor.editor.format("underline", false);
        this.texteditor.editor.format("decoration", false);
      }
    }
  },
  mounted() {
    this.active = this.value;
  },
  watch: {
    value() {
      this.active = this.value;
    }
  },
}
</script>
